import { TextField } from "@mui/material";
import { useState } from "react";
import { NumericFormat } from 'react-number-format';

export function NumericField({ value, onValueChange, emptyValue, showEmptyValue, log, ...otherProps }) {
    const tag = `${log ? (log + ' ') : ''}NumericField`;

    if (typeof value === 'number' && isNaN(value)) {
        console.warn(tag, `value is NaN`);
    }
    if (typeof value === 'string') {
        console.warn(tag, `value '${value}' type is string`);
    }

    const numberValue = toNumber(value);

    const [expectedValue, setExpectedValue] = useState(numberValue);
    const [localValue, setLocalValue] = useState(numberValue);

    if (expectedValue !== numberValue) {
        setExpectedValue(numberValue);
        setLocalValue(numberValue);
    }

    const needUseEmptyValue = showEmptyValue;
    const min = otherProps?.InputProps?.inputProps?.min;
    const max = otherProps?.InputProps?.inputProps?.max;
    

    log && console.log(
        tag,
        'value:', numberValue, `(${typeof numberValue})`,
        'expectedValue:', expectedValue, `(${typeof expectedValue})`,
        'localValue:', localValue, `(${typeof localValue})`,
    );

    const valueChangeHandler = (values) => {
        let nextValue = values.floatValue;

        log && console.log(tag, 'onChange:', nextValue);

        // Если введён '-', nextValue может быть NaN
        if (isNaN(nextValue)) {
            nextValue = undefined;
        }
        // Если значение стёрто, nextValue может быть undefined
        if (nextValue === undefined) {
            nextValue = emptyValue;

            // Локально оставляем старое значение, чтобы NumericFormat не перерисовывался
            setLocalValue(numberValue);
        } else {
            setLocalValue(nextValue);
        }
        if (numberValue !== nextValue) {
            setExpectedValue(nextValue);
            onValueChange && onValueChange(nextValue);
        }
    };

    const isAllowedHandler = (values) => {
        let nextValue = values.floatValue;

        if (needUseEmptyValue && nextValue === undefined) {
            nextValue = emptyValue;

            if (numberValue !== nextValue) {
                log && console.log(tag, 'isAllowed:', nextValue);

                setLocalValue(nextValue);
                setExpectedValue(nextValue);
                onValueChange && onValueChange(nextValue);
            }
            return false;
        }
        if (min !== undefined && nextValue < min) {
            return false;
        }
        if (max !== undefined && nextValue > max) {
            return false;
        }
        return true;
    };

    return (
        <NumericFormat
            customInput={TextField}

            allowedDecimalSeparators={[',']}
            decimalSeparator="."
            // allowNegative={false}
            // decimalScale={2}
            // fixedDecimalScale

            {...otherProps}

            value={localValue}

            isAllowed={isAllowedHandler}
            onValueChange={valueChangeHandler}
        />
    );
}

function toNumber(value) {
    let result = undefined;

    if (typeof value === 'number') {
        if (!isNaN(value)) {
            result = value;
        }
    } else if (value === null) {
        result = value;
    } else if (typeof value === 'string') {
        const num = Number(value);

        if (!isNaN(num)) {
            result = num;
        }
    }
    return result;
}